export const handleNavigate = (data) => {
    const path = `/${data.categoryName.toLowerCase()}/${data.categoryId}/details/${data.labSampleId}`;
    return path

  };